import React, { useState } from 'react'
import './Login.css'
import logo from './img/mycart login_logo.png'
import { Link, useHistory } from 'react-router-dom'
import { auth } from "./firebase"

function Login() {
    const history = useHistory();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const signIn = e => {
        e.preventDefault();

        auth
            .signInWithEmailAndPassword(email, password)
            .then(auth => {
                history.push('/')
            })
            .catch(error => alert(error.message))
    }
    const register = e => {
        e.preventDefault();

        auth
            .createUserWithEmailAndPassword(email, password)
            .then((auth) => {
                // it successfully created a new user with email and password
                if (auth) {
                    history.push('/')
                }
            })
            .catch(error => alert(error.message))
    }
         
    
    return (
        <div className="login">
          <Link to='/'>
          <img className="login__logo" alt="mycart_logo" src={logo} />
          </Link>
          <div className="login__container">
              <h1>Sign-in</h1>
              <form>
                    <h5>E-mail</h5>
                    <input type='text' value={email} onChange={e=> setEmail(e.target.value)}/>

                    <h5>Password</h5>
                    <input type='password' value={password} onChange={e=> setPassword(e.target.value)} pattern=".{8,}"/>

                  <button type="submit" onClick={signIn} className='login__signInButton'>Sign In</button>
                  <p>
                    By signing-in you agree to the Mycart Conditions of Use & Sale. Please
                    see our Privacy Notice, our Cookies Notice and our Interest-Based Ads Notice.
                </p>

                <button onClick={register} className='login__registerButton'>Create your Mycart Account</button>
                  <center> <p className="p__notice"><b>Google</b> and <b>Facebook</b> authentication coming soon...</p></center>
                </form>
          </div>
        </div>
    )
}

export default Login
